export const signersColorsArray = [
    '#ef7575',
    '#75d7ef',
    '#75ef85',
    '#c976e0',
    '#e0b776',
    '#d9e076',
    '#76e0b7',
    '#e076ce',
    '#a6e076',
    '#39845c',
    '#4b544f',
    '#444893',
    '#929344',
    '#93444a',
    '#284d56'
];
